import {ImageMeta} from '../model/models'

export default class ImageLogic {
  private static allowedFileTypes = ['image/jpeg', 'image/png']
  
  static isAllowedFileType(file: any) {
    if (!file || !file.type || !this.allowedFileTypes.includes(file.type)) {
      return false
    }
    return true
  }

  static getImageUrl(imageMeta: ImageMeta) {
    if (!imageMeta) {
      return '/images/image_placeholder.png'
    }
    return `/api/image/${imageMeta.id}${imageMeta.ext}`
  }
}
